import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { APP_CONFIG } from '@/constants/app.constants';
import { localeStorage } from '@/utils/locale-storage.util';
import type { AppLocale } from '@/types/common.types';

export interface SettingsState {
  locale: AppLocale;
  sidebarCollapsed: boolean;
}

const initialState: SettingsState = {
  locale: localeStorage.get() ?? (APP_CONFIG.DEFAULT_LOCALE as AppLocale),
  sidebarCollapsed: false,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setLocale(state, action: PayloadAction<AppLocale>) {
      state.locale = action.payload;
      localeStorage.set(action.payload);
    },
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload;
    },
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
  },
});

export const { setLocale, setSidebarCollapsed, toggleSidebar } = settingsSlice.actions;
export const settingsReducer = settingsSlice.reducer;
